import BlockHeader from 'components/common/BlockHeader';
import DatepickerField from 'components/common/DatepickerField';
import SelectField from 'components/common/SelectField';
import TextField from 'components/common/TextField';
import RadioField from 'components/OrderAggregators/components/RadioField';
import Colors from 'constants/colors';
import DeliveryPreferred from 'constants/delivery-preferred';
import FontStyles from 'constants/font-styles';
import { PreferredTimeOptions } from 'constants/preferred-delivery-time';
import i18n from 'i18n';
import React from 'react';
import { css } from 'styled-components';
import CustomMedia from 'util/custom-media-query';
import { applyStyles } from 'util/helpers';
import { required } from 'validation/validators';

const resetValues = (value, change, datepickerMin) => {
  if (value === DeliveryPreferred.on) {
    change(
      'deliveries.preferredDate',
      datepickerMin.format(i18n.t('common:dateFormat.default'))
    );
    change('deliveries.preferredTime', PreferredTimeOptions[0].value);
  }
};

const Delivery = ({
  className,
  existsFormInput,
  datepickerMin,
  datepickerMax,
  getState,
  change
}) => (
  <div className={className}>
    <BlockHeader>
      {i18n.t('orderAggregators:payment:delivery.header')}
    </BlockHeader>
    {/** お盆情報 */}
    {i18n.t('notice:obon.show') && 
      <dl className="notice">
        <dt>{i18n.t('notice:obon.title')}</dt>
        <dd>
          <div>{i18n.t('notice:obon.messages.1')}</div>
          <div>{i18n.t('notice:obon.messages.2')}</div>
          <div>{i18n.t('notice:obon.messages.3')}</div>
          <div>{i18n.t('notice:obon.messages.4')}</div>
          <div>{i18n.t('notice:obon.messages.5')}</div>
        </dd>
      </dl>
    }
    {i18n.t('notice:delivery.show')&&
      <dl className="notice">
        <dt>{i18n.t('notice:delivery.title')}</dt>
        <dd>
          <div>{i18n.t('notice:delivery.messages.1')}</div>
          <div>{i18n.t('notice:delivery.messages.2')}</div>
          <div>{i18n.t('notice:delivery.messages.3')}</div>
          <div>{i18n.t('notice:delivery.messages.4')}</div>
          <div>{i18n.t('notice:delivery.messages.5')}</div>
          <div>{i18n.t('notice:delivery.messages.6')}</div>
          <div>{i18n.t('notice:delivery.messages.7')}</div>
        </dd>
      </dl>
    }
    {existsFormInput && (
      <React.Fragment>
        <RadioField
          name="deliveries.deliveryPreferred"
          labels={[
            i18n.t('orderAggregators:payment:delivery.preferredOff'),
            i18n.t('orderAggregators:payment:delivery.preferredOn')
          ]}
          values={[DeliveryPreferred.off, DeliveryPreferred.on]}
          onChange={v => resetValues(v.target.value, change, datepickerMin)}
        />

        {getState().values.deliveries.deliveryPreferred ===
        DeliveryPreferred.on ? (
          <React.Fragment>
            <DatepickerField
              name="deliveries.preferredDate"
              label={i18n.t('orderAggregators:payment:delivery.preferredDate')}
              required={true}
              minDate={datepickerMin.format(
                i18n.t('common:dateFormat.default')
              )}
              maxDate={datepickerMax.format(
                i18n.t('common:dateFormat.default')
              )}
              validate={value => required(value)}
              disable={i18n.t('notice:delivery.disable', { returnObjects: true })}
            />
            <SelectField
              name="deliveries.preferredTime"
              label={i18n.t('orderAggregators:payment:delivery.preferredTime')}
              required={true}
              options={PreferredTimeOptions}
            />
          </React.Fragment>
        ) : (
          <React.Fragment>
            <TextField
              name="deliveries.preferredDate"
              label={i18n.t('orderAggregators:payment:delivery.preferredDate')}
              value=""
              disabled={true}
            />
            <TextField
              name="deliveries.preferredTime"
              label={i18n.t('orderAggregators:payment:delivery.preferredTime')}
              value=""
              disabled={true}
            />
          </React.Fragment>
        )}
      </React.Fragment>
    )}

    <div className="description">
      <div className="description-label">
        {i18n.t('orderAggregators:payment:delivery.aboutDelivery')}
      </div>
      <ul>
        <li>
          {i18n.t('orderAggregators:payment:delivery.aboutDeliveryNote1')}
        </li>
      </ul>
    </div>

    <div className="description">
      <div className="description-label">
        {i18n.t('orderAggregators:payment:delivery.aboutReturn')}
      </div>
      {i18n.t('orderAggregators:payment:delivery.aboutReturnNote')}
    </div>
  </div>
);

const commonStyle = css`
  .indent1 {
    margin-left: 1em;
  }

  .notice {
    dl {
      margin: 0.75em 0 0;
  
      &:first-child {
        margin-top: 0;
      }
    }
  
    dt, dd {
      display: block;
      padding: 0;
      margin: 0;
    }
  
    dt {
      margin-bottom: 0.25em;
      margin-top: 1em;
      color: #ff6e3c;
      font-weight: bold;
      font-size: 20px;
      &:first-child {
        margin-top: 0;
      }
    }  
  }
  .description {
    .required-sign {
      position: relative;
      ${FontStyles.text7};

      &:after {
        content: ' ';
        position: absolute;
        left: 0;
        bottom: 0;
        border: 0;
        border-top: 1px solid ${Colors.orange1};
        margin-left: 0;
      }
    }

    ul {
      padding-left: 12px;
      margin-top: 8px;

      li {
        position: relative;
        list-style: none;

        &:before {
          position: absolute;
          top: 0.6rem;
          left: -0.7rem;
          content: '';
          display: inline-block;
          width: 7px;
          height: 7px;
          border-radius: 50%;
          background-color: ${Colors.black1};
        }
      }
    }
  }

  .description-label {
    ${FontStyles.text5};
    margin-top: 40px;
    margin-bottom: 16px;
  }
`;

const pcStyle = CustomMedia.greaterThan('umedium')`
  .delivery-radio-container {
    margin: 40px 0;
  }

  .description {
    ${FontStyles.text8};

    .required-sign {
      &:after {
        width: 308px;
      }
    }
  }
`;

const spStyle = CustomMedia.lessThan('medium')`
  ${BlockHeader} {
    margin-right: 16px;
    margin-left: 16px;
  }

  .description {
    ${FontStyles.text6};
    padding: 0 16px;

    .required-sign {
      &:after {
        width: 270px;
      }
    }
  }

  .notice {
    padding: 0 16px;
  }

`;

export default applyStyles(Delivery)(commonStyle, pcStyle, spStyle);



// WEBPACK FOOTER //
// ./src/components/OrderAggregators/Payment/components/Delivery.js